<template>
  <div class="relative w-full mt-12">
    <div
      class="flex flex-col flex-wrap min-w-0 break-words shadow-lg rounded-md bg-white"
    >
      <div class="flex justify-center">
        <BlogCreatePage v-if="blogOperationMode === 'create'" />
        <BlogEditPage v-if="blogOperationMode === 'edit'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BlogCreatePage from "@/components/ComponentModule/BlogComponent/BlogCreatePage";
import BlogEditPage from "@/components/ComponentModule/BlogComponent/BlogEditPage";

export default {
  name: "BlogPage",
  components: { BlogCreatePage, BlogEditPage },
  mounted() {
    this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
      region: this.getRegion,
      componentId: this.getComponentId("abi_blog")
    });
    if (
      this.$router.currentRoute.value.fullPath.split("/").includes("edit") &&
      this.operationMode !== "edit"
    ) {
      // if url has 'edit' keyword, set operation to edit
      this.$store.dispatch(Actions.CHANGE_BLOG_OPERATION, "edit");
    } else if (
      this.$router.currentRoute.value.fullPath.split("/").includes("create") &&
      this.operationMode !== "create"
    ) {
      // if url has 'create' keyword, set operation to create
      this.$store.dispatch(Actions.CHANGE_BLOG_OPERATION, "create");
    }
  },
  computed: {
    ...mapGetters(["blogOperationMode", "getRegion", "getAllComponent"])
  },
  methods: {
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
